var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"locale-item"},[_c('span',{staticClass:"locale-code"},[_vm._v(" "+_vm._s(_vm.code)+" ")]),_c('span',{staticClass:"locale-name"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }